export default __webpack_public_path__ + "static/media/optimal-solution.228ebca2.svg";